import React from "react";
import SkeletonBlock from "./SkeletonBlock";

/**
 * Shimmer placeholder that matches CompletedActivityCard's row layout (icon +
 * label + trailing meta on a `bg-card` pill) so history feeds fade in without a
 * layout shift.
 */
export default function CompletedActivityCardSkeleton({ showDetails = false }) {
  return (
    <div
      aria-hidden="true"
      className={`w-full rounded-2xl bg-card px-3 py-3 shadow flex ${
        showDetails ? "items-start" : "items-center"
      } gap-3`}
    >
      <SkeletonBlock className="h-[22px] w-[22px] rounded-lg shrink-0" />
      <div
        className={`flex min-w-0 flex-1 ${
          showDetails
            ? "flex-col items-start gap-2"
            : "items-center justify-between gap-3"
        }`}
      >
        <div className="flex w-full min-w-0 items-center justify-between gap-3">
          <SkeletonBlock className="h-4 w-32 max-w-[55%] rounded-full" />
          <SkeletonBlock className="h-3 w-12 rounded-full shrink-0" />
        </div>
        {showDetails ? (
          <div className="flex w-full flex-wrap items-center gap-1.5">
            <SkeletonBlock className="h-5 w-24 rounded-full" />
            <SkeletonBlock className="h-5 w-28 rounded-full" />
          </div>
        ) : null}
      </div>
    </div>
  );
}
